import { BucketBadge } from './BucketBadge';

// Complete-evaluation view (spec 2026-07-05): every clause, what it was checked
// against, and the outcome. Renders after the ruled-out section. Old reports
// (no clause_summary key) render nothing — same graceful-absence contract as
// section_ref.
const OUTCOME_LINE = {
  flagged: 'Flagged — see the warning above for this clause.',
  ruled_out: 'Checked — appears not to apply after review.',
  clean: 'Checked against the rules below — no concerns from this review.',
  no_rule: 'No specific Colorado rule triggered — general clause.',
};

// bucketFor() has no green path (it only classifies findings that fired), so a
// clause with no worst_finding gets a plain "Looks OK" chip matching
// BucketBadge's markup.
function LooksOkChip() {
  return (
    <span
      className="inline-block flex-none rounded-full bg-emerald-600 px-2.5 py-0.5 text-xs font-semibold text-white"
      title="No concerns from this review"
    >
      🟢 Looks OK
    </span>
  );
}

export function ClauseSummary({ entries }) {
  if (!entries?.length) return null;
  return (
    <section className="mt-8 animate-slide-in" aria-label="Clause-by-clause summary">
      <h3 className="text-2xl font-bold text-slate-800 dark:text-slate-100">Clause-by-Clause Summary</h3>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
        Every clause in your lease, what we checked it against, and the outcome. This is our
        evaluation, not a legal opinion.
      </p>
      <div className="mt-4 space-y-3">
        {entries.map((c) => (
          <div
            key={c.clause_id}
            className="rounded-xl bg-white/50 p-4 ring-1 ring-slate-200 backdrop-blur dark:bg-slate-800/40 dark:ring-slate-700"
          >
            <div className="flex items-center gap-2">
              {c.worst_finding ? <BucketBadge finding={c.worst_finding} /> : <LooksOkChip />}
              <h4 className="font-semibold text-slate-700 dark:text-slate-200">{c.clause_id}</h4>
            </div>
            {c.rules_evaluated.length > 0 && (
              <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                Applicable rule(s):{' '}
                {c.rules_evaluated
                  .map((r) => (r.citation ? `${r.title} (${r.citation})` : r.title))
                  .join('; ')}
              </p>
            )}
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">{OUTCOME_LINE[c.outcome]}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
